import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {hideSecondaryScreens, showPrimaryScreen} from "../../ScreenManager";
import {getGameManager} from "../../../game/GameManager";
import {Observable} from '~knockout/index';
import {game} from '../../../game/GameCore';
import {gameIsMuted} from '../../../game/audio/AudioManager';

var template = require('./PauseOverlay.html');

export var pauseScreenVisible: Observable<boolean>;

class GameplayPauseOverlayComponent extends Screen
{
    pauseScreenVisible: Observable<boolean>;


    /**
     * create a custom binding for the pause screen
     */
    createBindings()
    {
        this.pauseScreenVisible = pauseScreenVisible = ko.observable(false);
    }


    /**
     * hide the pause overlay and resume the game
     */
    resumeGame = () =>
    {
     //  resume the game

        getGameManager().resumeGame();

        //  hide the pause screen

        pauseScreenVisible(false);
    };


    /**
     * quit the game and return to the main menu
     */
    quitToMenu = () =>
    {
        //  pause the game

        getGameManager().pauseGame();

        //  show the main menu

        showPrimaryScreen('main-menu');
    };
}


/**
 * register this component with knockout
 */
export function registerGameplayPauseOverlayComponent()
{
    ko.components.register('pp-gameplay-pause-overlay',
        {
            viewModel: () => { return new GameplayPauseOverlayComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/pause-menu/PauseOverlay.ts